import { useState } from "react";
import { TileImg } from "./TileImg";
import { ImageLightbox } from "./ImageLightbox";
import { RENDER_VIEWS } from "./yourducks/RenderChips";
import { renderImagePath, renderFilename, duckTitle } from "../lib/api";

// A duck's tile as a button that opens the zoom viewer at its Front render. The renders are fetched only once the
// viewer opens; a duck with no front render yet keeps the plain tile.
export const DuckThumb = ({ c, buttonTestId, buttonClass = "rounded-xl", ...tile }) => {
  const [idx, setIdx] = useState(-1);
  const img = <TileImg tile={c.tile} {...tile} />;
  if (!c.render_assets?.front) return img;
  const title = duckTitle(c) || "duck";
  const images = RENDER_VIEWS.filter(([v]) => c.render_assets[v]).map(([v, label]) => ({
    src: renderImagePath(c, v),
    authed: true,
    label,
    filename: renderFilename(c, v),
  }));
  const open = (e) => {
    e.stopPropagation();
    setIdx(0);
  };
  return (
    <>
      <button
        type="button"
        data-testid={buttonTestId}
        aria-label={`Open the front render of ${title}`}
        onClick={open}
        className={`block ${buttonClass} transition-transform duration-200 hover:scale-[1.03] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-background`}
      >
        {img}
      </button>
      {idx >= 0 && (
        <ImageLightbox open onOpenChange={(o) => !o && setIdx(-1)} images={images} index={idx} onIndexChange={setIdx} alt={`${title} AI render`} />
      )}
    </>
  );
};
